/* =============================================================================
   SILO 1 — VEHÍCULOS Y DGT EN TARRAGONA
   -----------------------------------------------------------------------------
   Misma estructura que seguros.js. La página de categoría está escrita y
   publicada; las páginas comerciales están con el SEO preparado y publicada:
   false a la espera de contenido.
   ============================================================================= */

module.exports = {
  id: 'vehiculos',
  icono: 'mdi-car-outline',

  // URL de la categoría: /vehiculos  y  /cat/vehicles
  slug: { es: 'vehiculos', ca: 'vehicles' },

  /* Etiqueta corta para menús y footer. El h1 completo no cabe en el lateral. */
  tituloMenu: { es: 'Vehículos y DGT', ca: 'Vehicles i DGT' },

  whatsappPropio: false,

  categoria: {
    es: {
      titleSeo: 'Trámites de vehículos y DGT en Tarragona | Gestoría Riola',
      description:
        'Gestoría especializada en trámites de vehículos y DGT en Tarragona. Cambios de nombre, matriculaciones, informes y más. Resultado en menos de 24 h. Consúltanos por WhatsApp.',
      h1: 'Trámites de vehículos y DGT en Tarragona',
      subtitulo: 'Rápido, sin colas y con resultado en menos de 24 horas.',
      kwPrincipal: 'trámites DGT Tarragona',
      kwLongTail: [
        'gestoría vehículos Tarragona',
        'gestoría DGT Tarragona',
        'cambio de nombre vehículo Tarragona',
        'gestoría colaboradora DGT Tarragona'
      ],

      entradilla:
        '¿Necesitas hacer un trámite con tu vehículo o con la DGT en Tarragona? Mándanos los documentos por WhatsApp y nosotros nos encargamos de todo. Sin desplazamientos innecesarios. Sin esperas. Sin sorpresas en el precio.',

      heroCta: 'Consultar por WhatsApp — gratis y sin compromiso',

      secciones: [
        {
          h2: 'Gestoría especializada en vehículos y DGT en Tarragona desde 1935',
          parrafos: [
            'Somos Gestoría Riola, una gestoría familiar con más de 90 años de experiencia y cuatro generaciones especializadas en trámites de vehículos y gestiones con la Dirección General de Tráfico.',
            'No hacemos de todo. Nos especializamos en vehículos y transporte, y esa especialización se nota en los resultados.',
            'Estamos en el centro de Tarragona, en Rambla Nova 110, 2º 2ª. Pero la mayoría de nuestros clientes lo gestionan todo desde casa, por WhatsApp.'
          ]
        }
      ],

      serviciosTitulo: 'Trámites de vehículos y DGT que gestionamos en Tarragona',

      bloquesServicio: [
        {
          destacado: true,
          etiqueta: 'El más solicitado',
          h3: 'Cambio de nombre de vehículos',
          parrafos: [
            'El cambio de nombre o transferencia de vehículo es el trámite que más realizamos. Y el que más casuística tiene: hay muchos tipos de operación y muchos factores que afectan tanto a la documentación necesaria como al precio final.'
          ],
          subbloques: [
            {
              h4: 'Lo que hacemos',
              lista: [
                'Cambios de nombre estándar entre particulares',
                'Transferencias por herencia',
                'Transferencias de vehículos agrícolas con cambios en el ROMA',
                'Transferencias de vehículos que requieren certificados de transporte'
              ]
            },
            {
              h4: '¿Cuánto tarda?',
              parrafos: [
                'Si no hay ningún impedimento con el vehículo, en menos de 24 horas tienes el permiso de circulación en tu mano.'
              ]
            },
            {
              h4: '¿Cuánto cuesta?',
              parrafos: [
                'Depende del vehículo y del tipo de operación. Mándanos la documentación y te decimos el precio exacto sin compromiso.'
              ]
            }
          ],
          cta: 'Consultar cambio de nombre',
          ctaWhatsapp: 'Hola, necesito información sobre un cambio de nombre'
        },
        {
          h3: 'Notificación de venta de vehículo',
          parrafos: [
            'Si vendes un coche, la notificación de venta te protege de responsabilidades futuras. Es un trámite rápido, económico y con precio fijo: no está sujeto a liquidación de impuestos.'
          ],
          subbloques: [
            {
              h4: 'Lo que necesitamos',
              lista: [
                'Copia del DNI del vendedor y del comprador',
                'Contrato o factura de compraventa',
                'Copia de la documentación del vehículo'
              ]
            }
          ]
        },
        {
          h3: 'Matriculación de vehículos nuevos y de importación',
          parrafos: [
            'Si has comprado un vehículo en el extranjero o necesitas matricular uno nuevo, te acompañamos en todo el proceso.',
            'Con la documentación completa, en menos de 24 horas tienes número de matrícula y la autorización provisional para circular.',
            '¿No tienes las fichas técnicas españolas? Te asesoramos para hacer la homologación y obtenerlas.'
          ],
          enlaces: [
            {
              texto: 'Calcular el impuesto de matriculación',
              url: '/calculadora-matriculacion',
              icono: 'mdi-car-key'
            }
          ]
        },
        {
          h3: 'Informes de vehículos',
          parrafos: [
            'Antes de comprar un vehículo de segunda mano, comprueba su estado administrativo. Con solo la matrícula te decimos si tiene alguna incidencia, sin coste.'
          ],
          subbloques: [
            {
              h4: 'Tipos de informe',
              lista: [
                'Informe DGT: propietario, ITV, kilometraje y datos técnicos',
                'Informe RBM: cargas, embargos, reservas de dominio y leasing',
                'Informe Carfax: historial internacional del vehículo'
              ]
            }
          ]
        },
        {
          h3: 'Duplicado de documentación',
          lista: [
            'Duplicado del permiso de circulación, por extravío o rectificación de datos',
            'Duplicado del carnet de conducir, por extravío, cambio de NIE a DNI u otros cambios de datos'
          ]
        },
        {
          h3: 'Bajas de vehículos',
          lista: [
            'Bajas temporales',
            'Bajas definitivas por exportación'
          ]
        },
        {
          h3: 'Cambios de datos en DGT',
          parrafos: [
            'Cambios de domicilio, cambios de datos personales o del vehículo en la base de datos de la DGT.'
          ]
        },
        {
          h3: 'Gestión de impuestos vinculados al vehículo',
          lista: [
            'Impuesto municipal de circulación (IVTM)',
            'Impuesto de transmisiones patrimoniales (ITP)',
            'Impuesto de matriculación (IEDMT)',
            'Impuesto sobre las emisiones de CO2'
          ],
          enlaces: [
            {
              texto: 'Calculadora de ITP',
              url: '/calculadora-itp',
              icono: 'mdi-swap-horizontal'
            },
            {
              texto: 'Calculadora de matriculación',
              url: '/calculadora-matriculacion',
              icono: 'mdi-car-key'
            }
          ]
        },
        {
          h3: 'Inscripción y cancelación en el Registro de Bienes Muebles (RBM)',
          parrafos: [
            'Gestión de anotaciones, reservas de dominio y cancelaciones de cargas en el Registro de Bienes Muebles.'
          ]
        }
      ],

      proceso: {
        h2: '¿Cómo lo gestionamos?',
        intro: 'Sin colas. Sin desplazamientos. Sin volver tres veces a la oficina.',
        pasos: [
          {
            h3: 'Cuéntanos qué necesitas',
            texto: 'Por WhatsApp o por teléfono. Te decimos exactamente qué documentos hacen falta y cuánto cuesta. Sin compromiso.'
          },
          {
            h3: 'Nos mandas la documentación',
            texto: 'Por WhatsApp, por email o en persona en nuestra oficina de Tarragona.'
          },
          {
            h3: 'Nosotros lo gestionamos todo',
            texto: 'Tú no tienes que hacer nada más.'
          },
          {
            h3: 'Resultado en menos de 24 horas',
            texto: 'Te avisamos cuando está listo. Si necesitas que te lo enviemos a domicilio, también lo hacemos: envío certificado, sale el mismo día.'
          }
        ]
      },

      resenas: {
        h2: 'Lo que dicen nuestros clientes en Tarragona',
        intro: '4,9 estrellas en Google.',
        items: [
          {
            texto: 'Envié toda la documentación por WhatsApp y al día siguiente ya tenía el permiso de circulación. No pudo ser más sencillo.',
            autor: 'Lukas'
          },
          {
            texto: 'En apenas 7 minutos estaba hecho el cambio de nombre. Son de las pocas empresas que he visto con 4,9 estrellas en Google, bien merecidas.',
            autor: 'Pedro'
          },
          {
            texto: 'Me ayudaron con la exportación de mi coche a Lituania. Comunicación clara, trato amable y total seriedad.',
            autor: 'Paulius'
          },
          {
            texto: 'Desde que llegué a España todas mis compras y ventas de coches han pasado por esta gestoría. Te orientan con paciencia y amabilidad, cualidades difíciles de encontrar hoy en día.',
            autor: 'Micaela'
          }
        ]
      },

      faqs: [
        {
          q: '¿Cuánto cuesta el cambio de nombre de un vehículo en Tarragona?',
          a: 'Depende del tipo de operación y del vehículo. Mándanos la documentación y te damos el precio exacto sin compromiso. No hay costes ocultos.'
        },
        {
          q: '¿Cuánto tarda el cambio de nombre?',
          a: 'Si el vehículo no tiene ningún impedimento, en menos de 24 horas tienes el permiso de circulación.'
        },
        {
          q: '¿Cómo sé si un vehículo tiene cargas o embargos?',
          a: 'Con solo la matrícula te lo decimos al momento y sin coste. Si quieres un informe completo, también lo gestionamos.'
        },
        {
          q: '¿Puedo hacer el trámite sin venir a la oficina?',
          a: 'Sí. La mayoría de nuestros clientes lo gestionan todo por WhatsApp desde casa.'
        },
        {
          q: '¿Enviáis la documentación a domicilio?',
          a: 'Sí. Todos los envíos son certificados y salen el mismo día que recibimos la documentación.'
        },
        {
          q: '¿Hacéis trámites complejos como herencias o importaciones?',
          a: 'Sí. Es precisamente donde más nos diferenciamos. Los trámites complejos son los que más dominamos.'
        }
      ],

      ctaTitulo: '¿Necesitas hacer un trámite de vehículo en Tarragona?',
      ctaTexto: 'Consúltanos sin compromiso. Te decimos exactamente qué necesitas, cuánto cuesta y cuánto tarda, antes de que tengas que tomar ninguna decisión.',
      ctaWhatsapp: 'Hola, necesito información sobre un trámite'
    },

    ca: {
      titleSeo: 'Tràmits de vehicles i DGT a Tarragona | Gestoria Riola',
      description:
        'Gestoria especialitzada en tràmits de vehicles i DGT a Tarragona. Canvis de nom, matriculacions, informes i més. Resultat en menys de 24 h. Consulta\'ns per WhatsApp.',
      h1: 'Tràmits de vehicles i DGT a Tarragona',
      subtitulo: 'Ràpid, sense cues i amb resultat en menys de 24 hores.',
      kwPrincipal: 'tràmits DGT Tarragona',
      kwLongTail: [
        'gestoria vehicles Tarragona',
        'gestoria DGT Tarragona',
        'canvi de nom vehicle Tarragona',
        'gestoria col·laboradora DGT Tarragona'
      ],

      entradilla:
        'Necessites fer un tràmit amb el teu vehicle o amb la DGT a Tarragona? Envia\'ns els documents per WhatsApp i nosaltres ens encarreguem de tot. Sense desplaçaments innecessaris. Sense esperes. Sense sorpreses en el preu.',

      heroCta: 'Consultar per WhatsApp — gratis i sense compromís',

      secciones: [
        {
          h2: 'Gestoria especialitzada en vehicles i DGT a Tarragona des del 1935',
          parrafos: [
            'Som Gestoria Riola, una gestoria familiar amb més de 90 anys d\'experiència i quatre generacions especialitzades en tràmits de vehicles i gestions amb la Direcció General de Trànsit.',
            'No ho fem tot. Ens especialitzem en vehicles i transport, i aquesta especialització es nota en els resultats.',
            'Som al centre de Tarragona, a la Rambla Nova 110, 2n 2a. Però la majoria dels nostres clients ho gestionen tot des de casa, per WhatsApp.'
          ]
        }
      ],

      serviciosTitulo: 'Tràmits de vehicles i DGT que gestionem a Tarragona',

      bloquesServicio: [
        {
          destacado: true,
          etiqueta: 'El més sol·licitat',
          h3: 'Canvi de nom de vehicles',
          parrafos: [
            'El canvi de nom o transferència de vehicle és el tràmit que més fem. I el que té més casuística: hi ha molts tipus d\'operació i molts factors que afecten tant la documentació necessària com el preu final.'
          ],
          subbloques: [
            {
              h4: 'El que fem',
              lista: [
                'Canvis de nom estàndard entre particulars',
                'Transferències per herència',
                'Transferències de vehicles agrícoles amb canvis al ROMA',
                'Transferències de vehicles que requereixen certificats de transport'
              ]
            },
            {
              h4: 'Quant triga?',
              parrafos: [
                'Si no hi ha cap impediment amb el vehicle, en menys de 24 hores tens el permís de circulació a la mà.'
              ]
            },
            {
              h4: 'Quant costa?',
              parrafos: [
                'Depèn del vehicle i del tipus d\'operació. Envia\'ns la documentació i et diem el preu exacte sense compromís.'
              ]
            }
          ],
          cta: 'Consultar canvi de nom',
          ctaWhatsapp: 'Hola, necessito informació sobre un canvi de nom'
        },
        {
          h3: 'Notificació de venda de vehicle',
          parrafos: [
            'Si véns un cotxe, la notificació de venda et protegeix de responsabilitats futures. És un tràmit ràpid, econòmic i amb preu fix: no està subjecte a liquidació d\'impostos.'
          ],
          subbloques: [
            {
              h4: 'El que necessitem',
              lista: [
                'Còpia del DNI del venedor i del comprador',
                'Contracte o factura de compravenda',
                'Còpia de la documentació del vehicle'
              ]
            }
          ]
        },
        {
          h3: 'Matriculació de vehicles nous i d\'importació',
          parrafos: [
            'Si has comprat un vehicle a l\'estranger o necessites matricular-ne un de nou, t\'acompanyem en tot el procés.',
            'Amb la documentació completa, en menys de 24 hores tens número de matrícula i l\'autorització provisional per circular.',
            'No tens les fitxes tècniques espanyoles? T\'assessorem per fer l\'homologació i obtenir-les.'
          ],
          enlaces: [
            {
              texto: 'Calcular l\'impost de matriculació',
              url: '/calculadora-matriculacion-cat',
              icono: 'mdi-car-key'
            }
          ]
        },
        {
          h3: 'Informes de vehicles',
          parrafos: [
            'Abans de comprar un vehicle de segona mà, comprova\'n l\'estat administratiu. Només amb la matrícula et diem si té alguna incidència, sense cap cost.'
          ],
          subbloques: [
            {
              h4: 'Tipus d\'informe',
              lista: [
                'Informe DGT: propietari, ITV, quilometratge i dades tècniques',
                'Informe RBM: càrregues, embargaments, reserves de domini i lísing',
                'Informe Carfax: historial internacional del vehicle'
              ]
            }
          ]
        },
        {
          h3: 'Duplicat de documentació',
          lista: [
            'Duplicat del permís de circulació, per extraviament o rectificació de dades',
            'Duplicat del carnet de conduir, per extraviament, canvi de NIE a DNI o altres canvis de dades'
          ]
        },
        {
          h3: 'Baixes de vehicles',
          lista: [
            'Baixes temporals',
            'Baixes definitives per exportació'
          ]
        },
        {
          h3: 'Canvis de dades a la DGT',
          parrafos: [
            'Canvis de domicili, canvis de dades personals o del vehicle a la base de dades de la DGT.'
          ]
        },
        {
          h3: 'Gestió d\'impostos vinculats al vehicle',
          lista: [
            'Impost municipal de circulació (IVTM)',
            'Impost de transmissions patrimonials (ITP)',
            'Impost de matriculació (IEDMT)',
            'Impost sobre les emissions de CO2'
          ],
          enlaces: [
            {
              texto: 'Calculadora d\'ITP',
              url: '/calculadora-itp-cat',
              icono: 'mdi-swap-horizontal'
            },
            {
              texto: 'Calculadora de matriculació',
              url: '/calculadora-matriculacion-cat',
              icono: 'mdi-car-key'
            }
          ]
        },
        {
          h3: 'Inscripció i cancel·lació al Registre de Béns Mobles (RBM)',
          parrafos: [
            'Gestió d\'anotacions, reserves de domini i cancel·lacions de càrregues al Registre de Béns Mobles.'
          ]
        }
      ],

      proceso: {
        h2: 'Com ho gestionem?',
        intro: 'Sense cues. Sense desplaçaments. Sense tornar tres vegades a l\'oficina.',
        pasos: [
          {
            h3: 'Explica\'ns què necessites',
            texto: 'Per WhatsApp o per telèfon. Et diem exactament quins documents calen i quant costa. Sense compromís.'
          },
          {
            h3: 'Ens envies la documentació',
            texto: 'Per WhatsApp, per email o en persona a la nostra oficina de Tarragona.'
          },
          {
            h3: 'Nosaltres ho gestionem tot',
            texto: 'Tu no has de fer res més.'
          },
          {
            h3: 'Resultat en menys de 24 hores',
            texto: 'T\'avisem quan està llest. Si necessites que te\'l enviem a domicili, també ho fem: enviament certificat, surt el mateix dia.'
          }
        ]
      },

      resenas: {
        h2: 'Què diuen els nostres clients a Tarragona',
        intro: '4,9 estrelles a Google.',
        items: [
          {
            texto: 'Vaig enviar tota la documentació per WhatsApp i l\'endemà ja tenia el permís de circulació. No podia ser més senzill.',
            autor: 'Lukas'
          },
          {
            texto: 'En tot just 7 minuts estava fet el canvi de nom. Són de les poques empreses que he vist amb 4,9 estrelles a Google, ben merescudes.',
            autor: 'Pedro'
          },
          {
            texto: 'Em van ajudar amb l\'exportació del meu cotxe a Lituània. Comunicació clara, tracte amable i total serietat.',
            autor: 'Paulius'
          },
          {
            texto: 'Des que vaig arribar a Espanya totes les meves compres i vendes de cotxes han passat per aquesta gestoria. T\'orienten amb paciència i amabilitat, qualitats difícils de trobar avui dia.',
            autor: 'Micaela'
          }
        ]
      },

      faqs: [
        {
          q: 'Quant costa el canvi de nom d\'un vehicle a Tarragona?',
          a: 'Depèn del tipus d\'operació i del vehicle. Envia\'ns la documentació i et donem el preu exacte sense compromís. No hi ha costos ocults.'
        },
        {
          q: 'Quant triga el canvi de nom?',
          a: 'Si el vehicle no té cap impediment, en menys de 24 hores tens el permís de circulació.'
        },
        {
          q: 'Com sé si un vehicle té càrregues o embargaments?',
          a: 'Només amb la matrícula t\'ho diem a l\'instant i sense cost. Si vols un informe complet, també el gestionem.'
        },
        {
          q: 'Puc fer el tràmit sense venir a l\'oficina?',
          a: 'Sí. La majoria dels nostres clients ho gestionen tot per WhatsApp des de casa.'
        },
        {
          q: 'Envieu la documentació a domicili?',
          a: 'Sí. Tots els enviaments són certificats i surten el mateix dia que rebem la documentació.'
        },
        {
          q: 'Feu tràmits complexos com herències o importacions?',
          a: 'Sí. És precisament on més ens diferenciem. Els tràmits complexos són els que més dominem.'
        }
      ],

      ctaTitulo: 'Necessites fer un tràmit de vehicle a Tarragona?',
      ctaTexto: 'Consulta\'ns sense compromís. Et diem exactament què necessites, quant costa i quant triga, abans que hagis de prendre cap decisió.',
      ctaWhatsapp: 'Hola, necessito informació sobre un tràmit'
    }
  },

  grupos: [
    {
      id: 'habituales',
      es: { titulo: 'Los trámites de siempre', subtitulo: 'Resueltos el mismo día' },
      ca: { titulo: 'Els tràmits de sempre', subtitulo: 'Resolts el mateix dia' }
    },
    {
      id: 'complejos',
      es: { titulo: 'Los que otros no quieren', subtitulo: 'Aquí es donde se nota la experiencia' },
      ca: { titulo: 'Els que altres no volen', subtitulo: 'Aquí és on es nota l\'experiència' }
    }
  ],

  servicios: [
    {
      slug: { es: 'transferencia-tarragona', ca: 'transferencia-tarragona' },
      grupo: 'habituales',
      icono: 'mdi-swap-horizontal',
      publicada: false,
      es: {
        titleSeo: 'Transferencia de vehículo en Tarragona | Gestoría Riola',
        description:
          'Hacemos el cambio de titularidad de tu coche o moto en Tarragona el mismo día. Te decimos qué documentos hacen falta y cuánto vas a pagar de ITP.',
        h1: 'Transferencia de vehículo en Tarragona',
        kwPrincipal: 'transferencia de vehículo Tarragona',
        kwLongTail: [
          'cambio de titularidad coche Tarragona',
          'transferencia de coche entre particulares Tarragona',
          'cuánto cuesta una transferencia en Tarragona',
          'transferencia de vehículo heredado Tarragona'
        ],
        resumen: 'Cambio de titularidad resuelto el mismo día, con el ITP calculado antes de que te comprometas.',
        entradilla: '',
        guionH2: [
          'Qué documentación necesitas',
          'Cuánto cuesta: tasa DGT, ITP y honorarios',
          'La exención del ITP en Cataluña para vehículos de más de 10 años',
          'Cómo lo hacemos sin que vengas a la oficina',
          'Casos especiales: herencias, embargos y vehículos de empresa'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['matriculacion-tarragona', 'baja-vehiculo-tarragona'],
        ctaTitulo: '¿Vas a comprar o vender un vehículo?',
        ctaTexto: 'Mándanos la ficha técnica y el permiso de circulación y te decimos el coste exacto.',
        ctaWhatsapp: 'Hola, quiero hacer una transferencia de vehículo'
      },
      ca: {
        titleSeo: 'Transferència de vehicle a Tarragona | Gestoria Riola',
        description:
          'Fem el canvi de titularitat del teu cotxe o moto a Tarragona el mateix dia. Et diem quins documents calen i quant pagaràs d\'ITP.',
        h1: 'Transferència de vehicle a Tarragona',
        kwPrincipal: 'transferència de vehicle Tarragona',
        kwLongTail: [
          'canvi de titularitat cotxe Tarragona',
          'transferència de cotxe entre particulars Tarragona',
          'quant costa una transferència a Tarragona'
        ],
        resumen: 'Canvi de titularitat resolt el mateix dia, amb l\'ITP calculat abans que et comprometis.',
        entradilla: '',
        guionH2: [
          'Quina documentació necessites',
          'Quant costa: taxa DGT, ITP i honoraris',
          'L\'exempció de l\'ITP a Catalunya per a vehicles de més de 10 anys',
          'Com ho fem sense que vinguis a l\'oficina',
          'Casos especials: herències, embargaments i vehicles d\'empresa'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['matriculacion-tarragona', 'baja-vehiculo-tarragona'],
        ctaTitulo: 'Compraràs o vendràs un vehicle?',
        ctaTexto: 'Envia\'ns la fitxa tècnica i el permís de circulació i et diem el cost exacte.',
        ctaWhatsapp: 'Hola, vull fer una transferència de vehicle'
      }
    },

    {
      slug: { es: 'matriculacion-tarragona', ca: 'matriculacio-tarragona' },
      grupo: 'habituales',
      icono: 'mdi-card-text-outline',
      publicada: false,
      es: {
        titleSeo: 'Matriculación de vehículos en Tarragona | Gestoría Riola',
        description:
          'Matriculación de vehículos nuevos, importados y de segunda mano en Tarragona. Gestionamos el impuesto de matriculación y la ficha técnica.',
        h1: 'Matriculación de vehículos en Tarragona',
        kwPrincipal: 'matriculación de vehículos Tarragona',
        kwLongTail: [
          'matricular coche importado Tarragona',
          'matriculación vehículo nuevo Tarragona',
          'matricular moto Tarragona'
        ],
        resumen: 'Nuevos, importados o de segunda mano. Incluida la ficha técnica y el impuesto de matriculación.',
        entradilla: '',
        guionH2: [
          'Vehículo nuevo, importado o rematriculación',
          'El impuesto de matriculación y de qué depende',
          'Homologación y ficha técnica reducida',
          'Vehículos traídos de otro país de la UE'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['transferencia-tarragona', 'informe-vehiculo-tarragona'],
        ctaTitulo: '¿Tienes un vehículo por matricular?',
        ctaTexto: 'Cuéntanos su procedencia y te decimos qué papeles hacen falta.',
        ctaWhatsapp: 'Hola, necesito matricular un vehículo'
      },
      ca: {
        titleSeo: 'Matriculació de vehicles a Tarragona | Gestoria Riola',
        description:
          'Matriculació de vehicles nous, importats i de segona mà a Tarragona. Gestionem l\'impost de matriculació i la fitxa tècnica.',
        h1: 'Matriculació de vehicles a Tarragona',
        kwPrincipal: 'matriculació de vehicles Tarragona',
        kwLongTail: [
          'matricular cotxe importat Tarragona',
          'matriculació vehicle nou Tarragona'
        ],
        resumen: 'Nous, importats o de segona mà. Inclosa la fitxa tècnica i l\'impost de matriculació.',
        entradilla: '',
        guionH2: [
          'Vehicle nou, importat o rematriculació',
          'L\'impost de matriculació i de què depèn',
          'Homologació i fitxa tècnica reduïda',
          'Vehicles portats d\'un altre país de la UE'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['transferencia-tarragona', 'informe-vehiculo-tarragona'],
        ctaTitulo: 'Tens un vehicle per matricular?',
        ctaTexto: 'Explica\'ns la seva procedència i et diem quins papers calen.',
        ctaWhatsapp: 'Hola, necessito matricular un vehicle'
      }
    },

    {
      slug: { es: 'duplicado-permiso-tarragona', ca: 'duplicat-permis-tarragona' },
      grupo: 'habituales',
      icono: 'mdi-file-document-multiple-outline',
      publicada: false,
      es: {
        titleSeo: 'Duplicado del permiso de circulación en Tarragona | Gestoría Riola',
        description:
          'Duplicado del permiso de circulación o del carnet de conducir en Tarragona. Lo tramitamos el mismo día y te lo enviamos certificado a casa.',
        h1: 'Duplicado de permiso en Tarragona',
        kwPrincipal: 'duplicado permiso de circulación Tarragona',
        kwLongTail: [
          'duplicado carnet de conducir Tarragona',
          'he perdido el permiso de circulación Tarragona',
          'duplicado ficha técnica Tarragona'
        ],
        resumen: 'Permiso de circulación, carnet o ficha técnica. Perdido, robado o deteriorado.',
        entradilla: '',
        guionH2: [
          'Permiso de circulación, carnet y ficha técnica',
          'Qué hacer si te lo han robado',
          'Documentación y plazos',
          'Renovación del carnet de conducir'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['cambio-domicilio-dgt-tarragona', 'transferencia-tarragona'],
        ctaTitulo: '¿Has perdido algún documento del coche?',
        ctaTexto: 'Dinos cuál y te lo tramitamos hoy mismo.',
        ctaWhatsapp: 'Hola, necesito un duplicado de permiso'
      },
      ca: {
        titleSeo: 'Duplicat del permís de circulació a Tarragona | Gestoria Riola',
        description:
          'Duplicat del permís de circulació o del carnet de conduir a Tarragona. El tramitem el mateix dia i te l\'enviem certificat a casa.',
        h1: 'Duplicat de permís a Tarragona',
        kwPrincipal: 'duplicat permís de circulació Tarragona',
        kwLongTail: [
          'duplicat carnet de conduir Tarragona',
          'he perdut el permís de circulació Tarragona'
        ],
        resumen: 'Permís de circulació, carnet o fitxa tècnica. Perdut, robat o deteriorat.',
        entradilla: '',
        guionH2: [
          'Permís de circulació, carnet i fitxa tècnica',
          'Què fer si te l\'han robat',
          'Documentació i terminis',
          'Renovació del carnet de conduir'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['cambio-domicilio-dgt-tarragona', 'transferencia-tarragona'],
        ctaTitulo: 'Has perdut algun document del cotxe?',
        ctaTexto: 'Digues-nos quin i te\'l tramitem avui mateix.',
        ctaWhatsapp: 'Hola, necessito un duplicat de permís'
      }
    },

    {
      slug: { es: 'baja-vehiculo-tarragona', ca: 'baixa-vehicle-tarragona' },
      grupo: 'habituales',
      icono: 'mdi-car-off',
      publicada: false,
      es: {
        titleSeo: 'Baja de vehículo en Tarragona | Gestoría Riola',
        description:
          'Baja temporal o definitiva de tu vehículo en Tarragona. Deja de pagar impuestos y seguro por un coche que ya no usas. Lo tramitamos el mismo día.',
        h1: 'Baja de vehículo en Tarragona',
        kwPrincipal: 'baja de vehículo Tarragona',
        kwLongTail: [
          'baja temporal de vehículo Tarragona',
          'baja definitiva coche Tarragona',
          'dar de baja un coche sin desguace Tarragona'
        ],
        resumen: 'Temporal o definitiva. Para dejar de pagar por un vehículo que no usas.',
        entradilla: '',
        guionH2: [
          'Baja temporal y baja definitiva: cuál te interesa',
          'Baja por desguace y certificado de destrucción',
          'Baja por exportación',
          'Qué pasa con el impuesto de circulación y el seguro'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['transferencia-tarragona', 'informe-vehiculo-tarragona'],
        ctaTitulo: '¿Tienes un coche parado que no usas?',
        ctaTexto: 'Te decimos qué tipo de baja te conviene y lo que te ahorras.',
        ctaWhatsapp: 'Hola, quiero dar de baja un vehículo'
      },
      ca: {
        titleSeo: 'Baixa de vehicle a Tarragona | Gestoria Riola',
        description:
          'Baixa temporal o definitiva del teu vehicle a Tarragona. Deixa de pagar impostos i assegurança per un cotxe que ja no fas servir.',
        h1: 'Baixa de vehicle a Tarragona',
        kwPrincipal: 'baixa de vehicle Tarragona',
        kwLongTail: [
          'baixa temporal de vehicle Tarragona',
          'baixa definitiva cotxe Tarragona'
        ],
        resumen: 'Temporal o definitiva. Per deixar de pagar per un vehicle que no fas servir.',
        entradilla: '',
        guionH2: [
          'Baixa temporal i baixa definitiva: quina t\'interessa',
          'Baixa per desballestament i certificat de destrucció',
          'Baixa per exportació',
          'Què passa amb l\'impost de circulació i l\'assegurança'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['transferencia-tarragona', 'informe-vehiculo-tarragona'],
        ctaTitulo: 'Tens un cotxe parat que no fas servir?',
        ctaTexto: 'Et diem quin tipus de baixa et convé i el que t\'estalvies.',
        ctaWhatsapp: 'Hola, vull donar de baixa un vehicle'
      }
    },

    {
      slug: { es: 'cambio-domicilio-dgt-tarragona', ca: 'canvi-domicili-dgt-tarragona' },
      grupo: 'habituales',
      icono: 'mdi-map-marker-outline',
      publicada: false,
      es: {
        titleSeo: 'Cambio de domicilio en la DGT en Tarragona | Gestoría Riola',
        description:
          'Actualiza tu dirección en la DGT y evita multas que nunca llegas a recibir. Lo tramitamos el mismo día desde Tarragona.',
        h1: 'Cambio de domicilio en la DGT en Tarragona',
        kwPrincipal: 'cambio de domicilio DGT Tarragona',
        kwLongTail: [
          'cambiar dirección permiso de circulación Tarragona',
          'actualizar domicilio carnet de conducir Tarragona'
        ],
        resumen: 'Es gratis, es rápido, y evita que te lleguen multas a una dirección donde ya no vives.',
        entradilla: '',
        guionH2: [
          'Por qué importa tenerlo actualizado',
          'Se cambia en el carnet y en el permiso de circulación',
          'Documentación necesaria',
          'Qué pasa con las multas notificadas a la dirección antigua'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['duplicado-permiso-tarragona'],
        ctaTitulo: '¿Te has mudado?',
        ctaTexto: 'Actualízalo antes de que te llegue una multa que nunca ves.',
        ctaWhatsapp: 'Hola, quiero cambiar mi domicilio en la DGT'
      },
      ca: {
        titleSeo: 'Canvi de domicili a la DGT a Tarragona | Gestoria Riola',
        description:
          'Actualitza la teva adreça a la DGT i evita multes que no arribes a rebre mai. Ho tramitem el mateix dia des de Tarragona.',
        h1: 'Canvi de domicili a la DGT a Tarragona',
        kwPrincipal: 'canvi de domicili DGT Tarragona',
        kwLongTail: [
          'canviar adreça permís de circulació Tarragona',
          'actualitzar domicili carnet de conduir Tarragona'
        ],
        resumen: 'És gratis, és ràpid, i evita que et arribin multes a una adreça on ja no vius.',
        entradilla: '',
        guionH2: [
          'Per què importa tenir-ho actualitzat',
          'Es canvia al carnet i al permís de circulació',
          'Documentació necessària',
          'Què passa amb les multes notificades a l\'adreça antiga'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['duplicado-permiso-tarragona'],
        ctaTitulo: 'T\'has mudat?',
        ctaTexto: 'Actualitza-ho abans que t\'arribi una multa que no veus mai.',
        ctaWhatsapp: 'Hola, vull canviar el meu domicili a la DGT'
      }
    },

    {
      slug: { es: 'informe-vehiculo-tarragona', ca: 'informe-vehicle-tarragona' },
      grupo: 'complejos',
      icono: 'mdi-file-search-outline',
      publicada: false,
      es: {
        titleSeo: 'Informe de vehículo de la DGT en Tarragona | Gestoría Riola',
        description:
          'Antes de comprar un coche de segunda mano, mira si tiene cargas, embargos o kilómetros manipulados. Informe oficial de la DGT en Tarragona.',
        h1: 'Informe de vehículo de la DGT en Tarragona',
        kwPrincipal: 'informe de vehículo DGT Tarragona',
        kwLongTail: [
          'comprobar cargas de un coche antes de comprar',
          'informe DGT coche segunda mano Tarragona',
          'saber si un coche tiene embargo Tarragona'
        ],
        resumen: 'Antes de pagar por un coche de segunda mano, comprueba que no arrastra cargas ni embargos.',
        entradilla: '',
        guionH2: [
          'Qué te dice el informe y qué no',
          'Cargas, embargos y precintos judiciales',
          'Histórico de titulares y de ITV',
          'Qué hacer si el informe sale con problemas'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['transferencia-tarragona', 'baja-vehiculo-tarragona'],
        ctaTitulo: '¿Vas a comprar un coche de segunda mano?',
        ctaTexto: 'Mándanos la matrícula y te sacamos el informe antes de que pagues nada.',
        ctaWhatsapp: 'Hola, quiero un informe de la DGT de un vehículo'
      },
      ca: {
        titleSeo: 'Informe de vehicle de la DGT a Tarragona | Gestoria Riola',
        description:
          'Abans de comprar un cotxe de segona mà, mira si té càrregues, embargaments o quilòmetres manipulats. Informe oficial de la DGT a Tarragona.',
        h1: 'Informe de vehicle de la DGT a Tarragona',
        kwPrincipal: 'informe de vehicle DGT Tarragona',
        kwLongTail: [
          'comprovar càrregues d\'un cotxe abans de comprar',
          'informe DGT cotxe segona mà Tarragona'
        ],
        resumen: 'Abans de pagar per un cotxe de segona mà, comprova que no arrossega càrregues ni embargaments.',
        entradilla: '',
        guionH2: [
          'Què et diu l\'informe i què no',
          'Càrregues, embargaments i precintes judicials',
          'Històric de titulars i d\'ITV',
          'Què fer si l\'informe surt amb problemes'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['transferencia-tarragona', 'baja-vehiculo-tarragona'],
        ctaTitulo: 'Compraràs un cotxe de segona mà?',
        ctaTexto: 'Envia\'ns la matrícula i et traiem l\'informe abans que paguis res.',
        ctaWhatsapp: 'Hola, vull un informe de la DGT d\'un vehicle'
      }
    }
  ]
};
